import React from 'react';
import './DeleteIssueModal.css';

/**
 * Modal de confirmação para exclusão de Bug/Melhoria (Issue).
 * CSS próprio (DeleteIssueModal.css) — não depende das classes .modal/.btn
 * genéricas compartilhadas por dezenas de outras telas do app.
 */
const DeleteIssueModal = ({ isOpen, onClose, onConfirm, issue }) => {
  if (!isOpen) return null;

  const label = issue?.test_case_title || issue?.title || `Item #${issue?.id || ''}`;
  const idLabel = issue?.id ? `ID ${issue.id}` : null;

  return (
    <div className="dim-overlay" onClick={onClose}>
      <div className="dim-card" onClick={(e) => e.stopPropagation()} role="alertdialog" aria-modal="true" aria-label="Confirmar exclusão">
        <button type="button" className="dim-close" onClick={onClose} aria-label="Fechar">×</button>

        <div className="dim-icon">🗑️</div>
        <h2 className="dim-title">Excluir Bug/Melhoria</h2>
        <p className="dim-message">
          Tem certeza que deseja excluir <strong>{label}</strong>?
        </p>
        {idLabel && <div className="dim-id-chip">{idLabel}</div>}

        <div className="dim-warning">
          <span className="dim-warning-icon">⚠️</span>
          <span>Esta ação é <strong>permanente</strong> e não pode ser desfeita.</span>
        </div>

        <div className="dim-actions">
          <button type="button" className="dim-btn dim-btn-cancel" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dim-btn dim-btn-confirm" onClick={onConfirm}>
            🗑️ Excluir definitivamente
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteIssueModal;
